import {forwardRef} from 'react'

import {twMerge} from '@sdox/utils'

import type {ComponentProps} from 'react'

export interface TextareaProps extends ComponentProps<'textarea'> {
  className?: string
  name?: string
  value?: string
  hasError?: boolean
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({name, value, hasError, className, ...restProps}, ref) => (
    <textarea
      ref={ref}
      name={name}
      value={value}
      className={twMerge(
        'rounded-[3px] border-0 p-2 ring-1 ring-inset ring-sdox-primary focus:ring-2 focus:ring-inset',
        hasError ? 'text-red-500 ring-red-500 placeholder:text-red-500 focus:ring-red-500' : '',
        className,
      )}
      {...restProps}
    />
  ),
)
